// setPointerCapture throws when the pointer is no longer active (synthetic or some pen/touch events).
export const capturePointer = (el, pointerId) => {
  try { el.setPointerCapture(pointerId); } catch (e) {
    if (e?.name !== "NotFoundError") console.warn("Pointer capture failed", e);
  }
};
